import { useEffect, useMemo, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import './CardEx.css';
import Tippy from "@tippyjs/react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import 'animate.css/animate.min.css';

const CardEx = ({ title, 
    titleParent, 
    children, 
    height, 
    isAvailableBreadcrumbs = false,
    isAvailableMaximized = false,
    isAvailableRefetch = false,
    enableScrollY= false,
    breadcrumbs, 
    onRefetch }) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
    };

    const cardStyle = {
        width: isMaximized ? '100vw' : '100%',
        height: isMaximized ? '100vh' : height,
        position: isMaximized ? 'fixed' : 'relative', // Cambia el posicionamiento
        top: isMaximized ? '0' : '', // Ajusta la posición superior
        left: isMaximized ? '0' : '', // Ajusta la posición izquierda
        zIndex: isMaximized ? '1000' : '100',
        overflow: isMaximized ? 'auto' : 'visible', // Agrega desbordamiento scroll cuando está maximizado,
    };


    const cardBodyStyle = {
        overflowY: enableScrollY ? 'scroll': 'visible'
    };

    const cardHeaderStyle = useMemo(() => ({ height: '50px' }), []);

    // useEffect(() => {
    //     console.info(isAvailableMaximized, "isAvailableMaximized");
    //     //console.info(cardStyle, "cardStyle");
    // }, [])

    return (
        <Card style={cardStyle}>
            <Card.Header style={cardHeaderStyle}>
                <div className="w-100 d-flex justify-content-between">
                    <div className="d-flex align-items-center fs-3 fw-bold">
                        <div>
                            {title}
                        </div>

                        {isAvailableBreadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && isMaximized &&
                            (
                                <div className="d-flex align-items-center">
                                    <span className='h-20px border-gray-200 border-start mx-4'></span>
                                    <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1'>
                                        {Array.from(breadcrumbs).map((item, index) => (
                                            <li
                                                className={clsx('breadcrumb-item', {
                                                    'text-dark': !item.isSeparator && item.isActive,
                                                    'text-muted': !item.isSeparator && !item.isActive,
                                                })}
                                                key={`${item.path}${index}`}
                                            >
                                                {!item.isSeparator && item.path.length > 0 && (
                                                    <Link className='text-muted text-hover-primary' to={item.path}>
                                                        {item.title}
                                                    </Link>
                                                )}

                                                {!item.isSeparator && item.path.length == 0 && (
                                                    <span className='text-muted text-hover-primary'>
                                                        {item.title}
                                                    </span>
                                                )}

                                                {item.isSeparator && (
                                                    <span className='bullet bg-gray-200 w-5px h-2px'></span>
                                                )}

                                                {/* {!item.isSeparator ? (
                                                <Link className='text-muted text-hover-primary' to={item.path}>
                                                {item.title}
                                                </Link>
                                            ) : (
                                                <span className='bullet bg-gray-200 w-5px h-2px'></span>
                                            )} */
                                                }
                                            </li>
                                        ))}
                                        <li className='breadcrumb-item text-muted'>
                                            <span className='bullet bg-gray-200 w-5px h-2px'></span>
                                        </li>
                                        <li className='breadcrumb-item text-dark'>
                                            <span className='text-muted text-hover-primary'>
                                                {titleParent}
                                            </span></li>
                                    </ul>
                                </div>
                            )}

                    </div>
                    <div className="d-flex align-items-center icons">
                        {/* 
                         * TODO: LAHC: Implementar despues acciones personalizadas en el Card 
                         */ }
                        {/* <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic" size="sm" >
                                Reportes
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        {/* <i className="fi fi-rr-download icon"></i>
                        <span className="h-20px border-gray-200 border-start mx-4"></span> */}
                        {
                            isAvailableRefetch 
                            && <i className={`fi fi-rr-refresh icon ${isFetching ? 'icon-fetching': ''}`} 
                                    onClick={async ()=> {
                                        if (isFetching) {
                                            return;
                                        }
                                        setIsFetching(true);
                                        const r = await onRefetch();
                                        setIsFetching(false);
                                    }}>
                                </i>
                        }
                        
                        {isAvailableRefetch && isAvailableMaximized && <span className="h-20px border-gray-200 border-start mx-4"></span>}
                        
                        {isAvailableMaximized && (isMaximized ? (<i className="fi fi-rr-compress icon" onClick={toggleMaximize}></i>) : <i className="fi fi-rr-expand icon" onClick={toggleMaximize}></i>)}
                        
                    </div>
                </div>
            </Card.Header>
            <Card.Body style={cardBodyStyle}>
                {children}
            </Card.Body>
        </Card>
    )
}

export default CardEx;